import React from 'react';
import { useNavigate } from 'react-router';

import {
  RoutingViews,
  SearchParams,
  routingPaths,
} from '@core/services/routingService';
import { navigateTransitioned } from '@helpers/app.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

import NotificationItem from './_notificationItem';

interface Props {
  notification: DemmiFS.NotificationVendor;
  onNavigate: () => void;
}

const NotificationOrderNew: React.FC<Props> = ({
  notification,
  onNavigate,
}) => {
  const CSSBlock = 'notification-order-new';
  const navigate = useNavigate();

  const onClickView = () => {
    navigateTransitioned({
      navigate,
      to: routingPaths[RoutingViews.ORDERS_ALL],
      search: {
        [SearchParams.ORDER_ID]: notification.orderDocID!,
      },
    });
    onNavigate();
  };

  return (
    <NotificationItem
      notification={notification}
      CSSBlock={CSSBlock}
      buttonText="View"
      buttonOnClick={onClickView}></NotificationItem>
  );
};

export default NotificationOrderNew;
